import { ReactComponent as QontactTextSVG } from '@assets/SVGs/GeneralUse/Qontact.svg';
import { ReactComponent as QontactBackgroundSVG } from '@assets/SVGs/GeneralUse/QontactBackground.svg';
import { useAuth } from '@contexts/authContext';
import Checkbox from '@mui/material/Checkbox';
import ResetPasswordModalScreen from '@screens/Authentication/ResetPasswordModalScreen';
import { ClickableWrapper } from '@shared/designSystem/ClickableWrapper';
import styles from '@styles/screens/NewLogIn.module.css';
import { useState } from 'react';
import { isMobile } from 'react-device-detect';


const LogInScreen = () => {

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [visibility, setVisibility] = useState(false)
    const [errorMessage, setErrorMessage] = useState(['', ''])

    const { logIn, logInWithGoogle, resetPassword } = useAuth();
    const [rememberMe, setRememberMe] = useState(false)
    const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] = useState(false)

    const onLogIn = async (e) => {
        e.preventDefault()
        try {
            await logIn(email, password, rememberMe)
        } catch(error) {
          switch (error.code) {
            case 'auth/invalid-email':
                setErrorMessage(["Por favor, ingresá un Email válido.", 'email'])
                break
            case 'auth/wrong-password':
                setErrorMessage(["La contraseña ingresada es incorrecta.", 'password'])
                break
            case 'auth/user-not-found':
                setErrorMessage(["No se encontró una cuenta con este Email.", 'email'])
                break
            default:
                setErrorMessage(["Algo salió mal. Por favor, intentá de nuevo.", 'both'])
                break
          }
          console.error(error.message)
        }
    }

    const onLogInWithGoogle = async (e) => {
        e.preventDefault()
        try {
            await logInWithGoogle(true)
        } catch(error) {
            console.error(error.message)
        }
    }


    return (
      <div className={styles['content-screen']} id='app-main'>

        <div className={styles['qontact-container']}>
            <QontactBackgroundSVG viewBox={isMobile ? "0 0 700 305" : "0 0 700 1050"} className={styles['qontact-background']}/>
            <div className={styles['qontact-text-container']}>
                <QontactTextSVG/>
            </div>
        </div>

        <div className={styles['login-form-container']}>

          <p className={styles['login-title-text']}>Bienvenid@</p>
          <p className={styles['login-subtitle-text']}>Iniciá sesión con tu email</p>
          <div/> {/* Spacer */}
          
          <div> {/* Wrapper */}
            <p className={styles['login-text']}>Email</p>
            <div className={`${styles['login-input-container']} ${errorMessage[1] === 'email' || errorMessage[1] === 'both' ? styles['error-border'] : ''}`}>
                <input type='text' placeholder='Ingresar email' className={styles['login-input-field']} onChange={(event) => {
                  setEmail(event.target.value)
                }}/>
            </div>
          </div>

          <div> {/* Wrapper */}
            <p className={styles['login-text']}>Contraseña</p>
            <div className={`${styles['login-input-container']} ${errorMessage[1] === 'password' || errorMessage[1] === 'both' ? styles['error-border'] : ''}`}>
                <input className={styles['login-input-field']} type={visibility ? 'text' : 'password'} placeholder='Contraseña' onChange={(event) => {
                  setPassword(event.target.value)
                }}/>
                <div style={{width: '25px', height: '40px', marginLeft: '10px', cursor: 'pointer'}} onClick={() => setVisibility(!visibility)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 18 14" fill="none">
                    <path d="M1 7C1 7 4 1 9.25 1C14.5 1 17.5 7 17.5 7C17.5 7 14.5 13 9.25 13C4 13 1 7 1 7Z" stroke={!visibility ? '#7D838F' : '#000000'} strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9.25 9.25C10.4926 9.25 11.5 8.24264 11.5 7C11.5 5.75736 10.4926 4.75 9.25 4.75C8.00736 4.75 7 5.75736 7 7C7 8.24264 8.00736 9.25 9.25 9.25Z" stroke={!visibility ? '#7D838F' : '#000000'} strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
            </div>
          </div>


          <div className={styles['login-misc-container']}>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginLeft: '-8px'}}>
              <Checkbox sx={{color: 'gray', width: '45px','&.Mui-checked': {color: 'black'}}} value={rememberMe} onChange={e => setRememberMe(!rememberMe)}/>
              <p className={styles['login-text']}>Recordar mi Usuario</p>
            </div>
            <ClickableWrapper onClick={() => setIsResetPasswordModalOpen(true)} width="auto">
              <p className={styles['login-text']} style={{color: '#EC6C56'}}>Olvidé mi Clave</p>
            </ClickableWrapper>
          </div>

          {errorMessage[0] && 
          <div className={styles['login-error-container']}>
            <p className={styles['error-text']}>{errorMessage[0]}</p>
          </div>
          }
          
          <div className={styles['login-buttons-container']}>
            <div className={styles['login-button']} onClick={onLogIn}>
              Iniciar Sesión
            </div>

            <div className={styles['login-button']} style={{color: 'black', backgroundColor: 'white', border: '1px solid #DDDFE3'}}
              onClick={onLogInWithGoogle}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none" style={{marginRight: "16px"}}>
                <path d="M26.7374 11.356H25.65V11.3H13.5V16.7H21.1295C20.0165 19.8435 17.0255 22.1 13.5 22.1C9.02678 22.1 5.4 18.4732 5.4 14C5.4 9.52678 9.02678 5.9 13.5 5.9C15.5648 5.9 17.4433 6.67895 18.8737 7.95132L22.6922 4.13285C20.281 1.88577 17.0559 0.5 13.5 0.5C6.04463 0.5 0 6.54463 0 14C0 21.4554 6.04463 27.5 13.5 27.5C20.9554 27.5 27 21.4554 27 14C27 13.0948 26.9069 12.2113 26.7374 11.356Z" fill="#FFC107"/>
                <path d="M1.55664 7.71642L5.99207 10.9692C7.19222 7.9979 10.0988 5.9 13.5001 5.9C15.5649 5.9 17.4434 6.67895 18.8738 7.95132L22.6922 4.13285C20.2811 1.88577 17.056 0.5 13.5001 0.5C8.31474 0.5 3.81789 3.42747 1.55664 7.71642Z" fill="#FF3D00"/>
                <path d="M13.4998 27.5C16.9869 27.5 20.1553 26.1655 22.5509 23.9954L18.3726 20.4597C16.9717 21.5252 15.2599 22.1014 13.4998 22.1C9.98847 22.1 7.007 19.861 5.8838 16.7365L1.48145 20.1283C3.7157 24.5003 8.25305 27.5 13.4998 27.5Z" fill="#4CAF50"/>
                <path d="M26.7374 11.3561H25.65V11.3H13.5V16.7H21.1295C20.5971 18.1961 19.638 19.5034 18.3708 20.4605L18.3728 20.4591L22.5511 23.9948C22.2554 24.2634 27 20.75 27 14C27 13.0949 26.9068 12.2113 26.7374 11.3561Z" fill="#1976D2"/>
              </svg>
              Continuar con Google
            </div>
          </div>
        </div>

        <ResetPasswordModalScreen
          isOpen={isResetPasswordModalOpen}
          initialEmail={email}
          onClose={() => setIsResetPasswordModalOpen(false)}
          onResetPassword={resetPassword}
        />
      </div>
    );
  }
  
export default LogInScreen;